import type { Said as SaidText } from '@app/shared'
import './said.css'

/**
 * One text in the script a shul's public site chose for it: its English, its
 * Hebrew, or the two side by side.
 *
 * Each half is its own element, so a layout can place the two and a bilingual
 * pair is visibly one: both halves take the family of the text around them —
 * Adanim Serif carries Hebrew beside serif English, Adanim Sans beside sans.
 * Hebrew standing alone is a Hebrew block, takes the Hebrew face, and holds the
 * text's own place, so it wears `className` as the English would have. Either
 * way the Hebrew is marked, set right to left and isolated from the Latin
 * around it, and the English is set left to right, so a sentence read inside a
 * Hebrew page keeps its closing period at its end.
 *
 * `heClassName` is the Hebrew's place in a pair — quieter, beside or under the
 * English — and never sets a family, which the pair decides.
 */
export function Said({
  said,
  className,
  heClassName,
}: {
  said: SaidText
  className?: string
  heClassName?: string
}) {
  if (!said.en && !said.he) return null
  if (!said.en) {
    return (
      <span className={cx('said-he', className)} lang="he" dir="rtl">
        {said.he}
      </span>
    )
  }
  return (
    <>
      <span className={className} dir="ltr">
        {said.en}
      </span>
      {said.he ? (
        <>
          {' '}
          <span className={cx('said-pair', heClassName)} lang="he" dir="rtl">
            {said.he}
          </span>
        </>
      ) : null}
    </>
  )
}

const cx = (...names: (string | undefined)[]) => names.filter(Boolean).join(' ')
